import { ComponentType, HTMLAttributes } from "react";
import EventsTrackWrapperClick from "../EventsTrackWrapperClick";

const EventsTrackClickFileSelectorLabel: ComponentType<
  HTMLAttributes<HTMLLabelElement>
> = (labelProps) => (
  <EventsTrackWrapperClick id={35}>
    <label {...labelProps} />
  </EventsTrackWrapperClick>
);

export default EventsTrackClickFileSelectorLabel;
